import React, { useEffect, useState } from "react";
import { Info, Plus } from "lucide-react";
import { Method, showToastNotification } from "@/utility/helper";
import { API_ENDPOINT, API_URL_ORDER_SERVICE } from "@/api/constant";
import { callApi } from "@/api/callApi";
import Modal from "@/components/common/models/Modal";
import FormField from "@/components/UI/FormField";

interface AddRefundReasonProp {
    modelType?: 'add' | 'update';
    show: boolean;
    onClose: () => void;
    onSuccess: () => void;
    subTitle?: string;
    reasonId?: string;
    reasonText?: string
};

interface StatesProp {
    reason: string
    isSubmitting: boolean
    error: string | null
}

const AddRefundReason: React.FC<AddRefundReasonProp> = ({ show, onClose, onSuccess, modelType = "add", subTitle, reasonText, reasonId }) => {
    const [states, setStates] = useState<StatesProp>({
        reason: '',
        isSubmitting: false,
        error: null
    });

    useEffect(() => {
        if (reasonText) handleChangeState({ reason: reasonText })
    }, [reasonText])

    const handleChangeState = (newState: Partial<typeof states>) => {
        setStates((prev) => ({
            ...prev,
            ...newState,
        }));
    };

    const onSubmit = async () => {
        try {
            handleChangeState({ isSubmitting: true })
            let PATH = `${API_URL_ORDER_SERVICE}${API_ENDPOINT.refund}/reason`;
            let method: Method;
            if (reasonId) {
                PATH = `${PATH}/${reasonId}`
                method = 'PATCH'
            } else {
                PATH = `${PATH}/add`
                method = 'POST'
            }
            await callApi(PATH, { method: method, data: { reason: states.reason } });
            onSuccess()
            showToastNotification("success", "Reason Added Successfully")
        } catch (error) {
            const err = error as { message: string };
            showToastNotification('danger', err.message);
            console.log('error is', error)
        } finally {
            handleChangeState({ isSubmitting: false });
            onClose()
        }
    };


    const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const reason = e.target.value;
        handleChangeState({ reason: reason });

        if (!reason || reason.length < 3) {
            handleChangeState({ error: 'Please enter reason atleast 3 char.' });
        } else {
            handleChangeState({ error: '' });
        }
    }

    return (
        <>
            <Modal
                show={show}
                onClose={onClose}
                title={modelType === "add" ? "Add Reason" : "Update Reason"}
            >
                <div className="p-4 h-full flex flex-col justify-between space-y-4">
                    {subTitle && (
                        <p className="text-gray-600 text-sm mb-4">{subTitle}</p>
                    )}

                    <div>
                        <FormField
                            value={states.reason}
                            onChange={(e) => handleReasonChange(e as React.ChangeEvent<HTMLInputElement>)}
                            placeholder="eg: Defective product..."
                            required
                        />
                        {states.error && <span className={`text-red-500 text-sm flex items-start gap-1 mt-1 `}><Info size={16} /> {states.error}</span>}
                    </div>
                    <div className="flex justify-end space-x-4">
                        <button
                            className="btn-secondary"
                            onClick={onClose}
                            disabled={states.isSubmitting}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={() => onSubmit()}
                            className="btn-primary"
                            disabled={states.isSubmitting}
                        >
                            {states.isSubmitting ? (
                                <span>Submitting...</span>
                            ) : (
                                <>
                                    <Plus size={16} /> {modelType === "add" ? "Add" : "Update"} Reason
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AddRefundReason;
